<template>
  <div class="windrose" :style="{ transform: `rotate(${rotation}deg)` }">
    <div class="windrose__circle"></div>
    <p
      class="windrose__center"
      :style="{ transform: `rotate(${360 - rotation}deg)` }"
    >
      N
    </p>
    <span class="windrose__direction--n"></span>
    <span class="windrose__direction--s"></span>
    <span class="windrose__direction--w"></span>
    <span class="windrose__direction--e"></span>
  </div>
</template>

<script>
export default {
  props: ['rotation'],
};
</script>

<style lang="scss" scoped>
.windrose {
  width: 80px;
  height: 80px;
  display: flex;
  justify-content: center;
  align-items: center;
  margin: 10px;
}

.windrose__circle {
  border: 1px solid #000;
  border-radius: 50%;
  width: 80%;
  height: 80%;
}

.windrose__center {
  position: absolute;
  font-weight: 700;
  color: $primaryColor;
}

.windrose__direction {
  position: absolute;
  display: block;
  background: black;
}
.windrose__direction--n {
  @extend .windrose__direction;
  top: 0;
  height: 20%;
  width: 2px;
  background: $primaryColor;
}
.windrose__direction--s {
  @extend .windrose__direction;
  bottom: 0;
  height: 20%;
  width: 2px;
}
.windrose__direction--w {
  @extend .windrose__direction;
  left: 0;
  width: 20%;
  height: 2px;
}
.windrose__direction--e {
  @extend .windrose__direction;
  right: 0;
  width: 20%;
  height: 2px;
}
</style>
